import type React from "react";
import { useT } from "i18n";
import "./SaveButton.scss";

interface SaveButtonProps {
  onSave: (submitOrder: boolean) => void;
}

const SaveButton = ({ onSave }: SaveButtonProps) => {
  const t = useT();
  return (
    <button
      className={"save-button"}
      onClick={() => {
        onSave(false);
      }}
    >
      {t("component.orders.saveAndExit", "Save and Exit")}
    </button>
  );
};

export default SaveButton;
